export default __webpack_public_path__ + "static/media/success.32cf0a56.png";